export const getDashboardDetails = `
    query getDashboardDetails {
        getDashboardDetails {
            cards {
                key
                label
                new_
                inProgress
                pastDue
            }
            inProgressTotals {
                manuallyAssigned
                resumeLater
            }
            inProgressReviews {
                applicantEmployeeId
                programId
                term
                lastName
                firstName
                programLabel
                manuallyAssigned
                pastDue
                resumeLater
            }
        }
}`;

export const getNextApplicationForReviewer = `
    mutation getNextApplicationForReviewer($programId: String!) {
        getNextApplicationForReviewer(programId: $programId) {
            applicantEmployeeId
            programId
            term
            status
            message
        }
    }
`;